import React, {
  FC,
  PropsWithChildren,
} from 'react';
import style from './index.module.scss';

interface IProps {
  onClick: () => void;
}

export const TopMenuButton: FC<IProps> = (props: PropsWithChildren<IProps>) => <div
  className={style.extraIcons}
  onClick={props.onClick}
>
  {props.children}
</div>;
